import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { Button } from '@applyboard/crystal-ui';
import { CreateApplicationButton } from '@applyboard/ab-application';
import { EligibleWithCondition } from "./EligibleWithCondition";
import { CefEventName } from "../../EventTracker";
import { applyAction } from "../CEF/Utilities/ResultsHelper";
export function StudentCheckEligibilityButton(_ref) {
  var _student$id;
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'hug' : _ref$width,
    onTrack = _ref.onTrack,
    openModalFn = _ref.openModalFn,
    program = _ref.program,
    eligibility = _ref.eligibility,
    school = _ref.school,
    student = _ref.student;
  var eligibilities = eligibility.eligibilities,
    loadingEligibility = eligibility.loading;
  if (loadingEligibility) {
    return /*#__PURE__*/React.createElement(DefaultStudentCheckEligibilityButton, {
      width: width
    });
  }
  var _ref2 = eligibilities !== null && eligibilities !== void 0 ? eligibilities : {},
    eligibilityResult = _ref2.eligibilityResult,
    eligibilitySearchData = _ref2.eligibilitySearchData,
    intakeAvailable = _ref2.intakeAvailable,
    recruitmentRestricted = _ref2.recruitmentRestricted;
  var programId = program.id;
  var userId = (_student$id = student === null || student === void 0 ? void 0 : student.id) !== null && _student$id !== void 0 ? _student$id : null;
  var onConditionalApply = function onConditionalApply() {
    onTrack(CefEventName.ClickedApplyNow);
    applyAction(programId, userId, eligibilitySearchData !== null && eligibilitySearchData !== void 0 ? eligibilitySearchData : null);
  };
  var _onTrackedClick = function onTrackedClick(eventName) {
    onTrack(eventName);
    openModalFn();
  };
  if (eligibilityResult === 'ineligible') {
    return /*#__PURE__*/React.createElement(Button, {
      emphasis: "outlined",
      intent: "negative",
      onClick: function onClick() {
        return _onTrackedClick(CefEventName.ClickedNotEligible);
      },
      width: width
    }, "Not Eligible");
  }
  if (intakeAvailable && !recruitmentRestricted && eligibilityResult === 'conditional') {
    return /*#__PURE__*/React.createElement(EligibleWithCondition, {
      onApply: onConditionalApply,
      emphasis: "outlined",
      width: width
    });
  }
  if (!intakeAvailable && !recruitmentRestricted && (eligibilityResult === 'eligible' || eligibilityResult === 'conditional')) {
    return /*#__PURE__*/React.createElement(Button, {
      emphasis: "outlined",
      intent: "warning",
      onClick: function onClick() {
        return _onTrackedClick(CefEventName.ClickedNoIntake);
      },
      width: width
    }, "No Intake");
  }
  if (student !== null && student !== void 0 && student.id && eligibilityResult === 'eligible' && intakeAvailable && !recruitmentRestricted) {
    var _student$name;
    return /*#__PURE__*/React.createElement(CreateApplicationButton, {
      buttonWidth: width,
      disableStudentSelector: true,
      hideIcon: true,
      label: "Apply Now",
      onClick: function onClick() {
        return onTrack(CefEventName.ClickedApplyNow);
      },
      pageName: window.location.pathname.includes('/programs') ? 'Program' : 'School',
      program: program,
      school: school,
      student: {
        id: student.id,
        name: (_student$name = student.name) !== null && _student$name !== void 0 ? _student$name : ''
      }
    });
  }

  // Default: Check Eligibility
  return /*#__PURE__*/React.createElement(DefaultStudentCheckEligibilityButton, {
    width: width,
    onTrackedClick: function onTrackedClick() {
      return _onTrackedClick(CefEventName.ClickedCheckEligibility);
    }
  });
}
function DefaultStudentCheckEligibilityButton(_ref3) {
  var width = _ref3.width,
    onTrackedClick = _ref3.onTrackedClick;
  return /*#__PURE__*/React.createElement(Button, {
    width: width,
    emphasis: "outlined",
    intent: "primary",
    onClick: function onClick() {
      return onTrackedClick ? onTrackedClick(CefEventName.ClickedCheckEligibility) : undefined;
    },
    disabled: !onTrackedClick,
    loading: !onTrackedClick
  }, onTrackedClick ? 'Apply Now' : 'Checking Eligibility...');
}